var result = {
    possibleTypes: {
        DynamicHero: ["CustomDynamicHero", "ProgramDynamicHero"],
        Embed: ["IFrame", "Qualifio", "Spotify"],
        Entity: [
            "Article",
            "BasicPage",
            "Contest",
            "CustomDynamicHero",
            "GeneralManualCollection",
            "HomePage",
            "HomePageManualCollection",
            "Interactive",
            "Participate",
            "Person",
            "Program",
            "ProgramDynamicHero",
            "ProgramOverview",
            "Team",
            "TicketOverview",
            "TopPick",
            "Video",
        ],
        Experience: ["Contest", "Interactive", "Participate", "Ticket"],
        Hero: ["CustomDynamicHero", "ProgramDynamicHero", "StaticHero"],
        HomePageCollectionChild: [
            "Article",
            "BasicPage",
            "Contest",
            "Interactive",
            "Participate",
            "Ticket",
            "Video",
        ],
        MarketingBanner: [
            "DefaultVtmGo",
            "DefaultVtmGoPlus",
            "MarketingBannerNews",
            "MarketingBannerVtm",
            "MarketingBannerVtmGo",
        ],
        MarketingBannerProgram: ["MarketingBannerCpbd", "MarketingBannerVtm"],
        Page: [
            "Article",
            "BasicPage",
            "Contest",
            "HomePage",
            "Interactive",
            "Participate",
            "Program",
            "ProgramOverview",
            "TicketOverview",
            "Video",
        ],
        ProgramHero: ["ProgramDynamicHero", "StaticHero"],
    },
};
export default result;
